import { useState } from "react";
import { Modal, Form, Row, Col, Button } from "react-bootstrap";

import { useIsMounted, useLambdaApi } from "hooks";
import { ButtonWithSpinner, ErrorMessages } from "components/common";

export default function AddSSHKey({ instance, sshKeys, getResources, close }) {
  const api = useLambdaApi();
  const isMounted = useIsMounted();
  const [isLoading, setIsLoading] = useState(false);
  const [sshKeyToAdd, setSshKeyToAdd] = useState(sshKeys[0].name);
  const [errors, setErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true);

    api
      .execute("ec2.instance.add_key", {
        instance_id: instance.instance_id,
        key: sshKeyToAdd,
      })
      .then(close)
      .catch((errors) => {
        setErrors(errors);
      })
      .finally(() => {
        getResources();
        isMounted.current && setIsLoading(false);
      });
  };

  return (
    <Modal
      show
      animation={false}
      onHide={close}
      size="lg"
      className="launch-instance-modal"
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title>Add SSH Key</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group as={Row} className="mb-3 form-group-plaintext">
            <Form.Label column sm="3">
              Instance
            </Form.Label>
            <Col sm="9">
              <Form.Control plaintext readOnly defaultValue={instance.name} />
            </Col>
          </Form.Group>

          {/* INSTANCE TYPE */}
          <Form.Group as={Row}>
            <Form.Label column sm="3">
              SSH Key to Add
            </Form.Label>
            <Col sm="8">
              <Form.Control
                as="select"
                name="instanceProfile"
                custom
                value={sshKeyToAdd}
                onChange={(e) => {
                  setSshKeyToAdd(e.target.value);
                  setErrors({});
                }}
                required
                isInvalid={!!errors.instance_type}
              >
                {sshKeys.map((key) => (
                  <option key={key.name} value={key.name}>
                    {key.name}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.instance_profile}
              </Form.Control.Feedback>
            </Col>
          </Form.Group>

          {/* GENERIC ERRORS */}
          <ErrorMessages
            errors={errors}
            keysToIgnore={["instance_profile"]}
            className="mt-3"
          ></ErrorMessages>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={close} disabled={isLoading}>
            Cancel
          </Button>
          <ButtonWithSpinner type="submit" isLoading={isLoading}>
            Add Key
          </ButtonWithSpinner>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
